var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-result',{attrs:{"status":"500","sub-title":_vm.title}})}
var staticRenderFns = []

export { render, staticRenderFns }